/**
 * Centralized currency formatting for the Fitvent platform.
 * All price display should use these helpers instead of hardcoding €.
 */

/**
 * Every currency an event can be priced in (the event currency pickers and
 * SELLABLE_CURRENCIES in lib/auth/organiser-application.ts offer EUR, GBP and
 * USD), plus the Swiss franc, which has no symbol of its own and is written as
 * its code. A code carries its own trailing space, because every caller puts
 * the symbol straight in front of the amount: "CHF 12.00", as "£12.00".
 */
const CURRENCY_SYMBOLS: Record<string, string> = {
  EUR: '€',
  GBP: '£',
  USD: '$',
  CHF: 'CHF ',
};

export function getCurrencySymbol(currency?: string | null): string {
  return CURRENCY_SYMBOLS[(currency || 'EUR').toUpperCase()] || '€';
}

/** Format a price in major units (e.g. 29.99) with the correct currency symbol. */
export function formatPrice(amount: number, currency?: string | null): string {
  const symbol = getCurrencySymbol(currency);
  // Thousands separators ("£3,450.00"): every screen showed "£3450.00".
  const body = Math.abs(amount).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${amount < 0 ? '-' : ''}${symbol}${body}`;
}

/** Format a price stored in cents (e.g. 2999) with the correct currency symbol. */
export function formatPriceCents(cents: number, currency?: string | null): string {
  return formatPrice(cents / 100, currency);
}
